import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeasonalRankingComponent } from './seasonal-ranking.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { WeightingComponent } from './components/weighting/weighting.component';
import { WeightingRowComponent } from './components/weighting-row/weighting-row.component';
import { ScoringComponent } from './components/scoring/scoring.component';
import { ScoringRowComponent } from './components/scoring-row/scoring-row.component';
import { RankingRowComponent } from './components/ranking-row/ranking-row.component';
import { WeightingEditToggleComponent } from './components/weighting-edit-toggle/weighting-edit-toggle.component';
import { ScoringInputComponent } from './components/scoring-input/scoring-input.component';

@NgModule({
  declarations: [SeasonalRankingComponent, WeightingComponent, WeightingRowComponent, ScoringComponent, ScoringRowComponent, RankingRowComponent, WeightingEditToggleComponent, ScoringInputComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: 'seasonal-ranking', component: SeasonalRankingComponent },
      { path: 'weighting/:rankingId', component: WeightingComponent },
      { path: 'scoring/:rankingId', component: ScoringComponent }
    ]),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class SeasonalRankingModule { }
